// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/follow-us-on-instagram-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const followUsOnInstagram22DE: PageEntry = {
  id: "post.follow-us-on-instagram-2-2",
  locale: "de",
  slug: "follow-us-on-instagram-2-2",
  seo: {
    title: "Azubi Speed-Dating: Wir waren dabei! | Dietz GmbH",
    description: "Azubi Speed-Dating: Wir waren dabei!",
  },
  type: "post",
  h1: "Azubi Speed-Dating: Wir waren dabei!",
  blocks: [
    { kind: "heading", level: 2, text: "Azubi Speed-Dating: Wir waren dabei!" },
    { kind: "paragraph", text: "Diese Woche hatten wir die Möglichkeit beim Azubi Speed-Dating der regionalen Initiative DoppelPASS dabei zu sein." },
    { kind: "paragraph", text: "DoppelPASS ist eine gemeinsame Initiative der Agentur für Arbeit Bamberg-Coburg, der regionalen Jobcenter von Coburg, dem HSC 2000 Coburg, dem HSC Business Club und der Mediengruppe Oberfranken." },
    { kind: "paragraph", text: "Wir nutzten diese Möglichkeit um mit interessierten Schülerinnen und Schülern ins Gespräch zu kommen und unsere Ausbildungsberufe vorzustellen." },
    { kind: "paragraph", text: "Bist auch du noch auf der Suche nach einem Ausbildungsplatz oder möchtest im Rahmen eines Praktikums erste Einblicke bekommen? Dann melde dich gerne bei uns!" }
  ],
};
